import slugify from 'slugify'

export default (link) =>
  slugify(link, { lower: true, remove: /[*+~.()'"!:@?]/g })
